/**
 * @file Defines the {@link AutospinInterfaceSetting} class.
 * @author Joe Thompson <joe.thompson@1x2gaming.com>
 */

 export class AutospinInterfaceSetting {

    /**
     * Function to determine whether setting is permanently checked/on
     * @memberof AutospinInterfaceSetting
     * @private
     * @instance
     * @type {function}
     */
    _checked

    /**
     * Flag to determine whether setting is disabled (hidden from UI)
     * @memberof AutospinInterfaceSetting
     * @private
     * @instance
     * @type {boolean}
     */
    _disabled
    
    /**
     * Stores function name for iron dog setting
     * @memberof AutospinInterfaceSetting
     * @private
     * @instance
     * @type {string}
     */
    _function

    /**
     * Stores index of setting
     * @memberof AutospinInterfaceSetting
     * @private
     * @instance
     * @type {number}
     */
    _index

    /**
     * Stores ID of input field
     * @memberof AutospinInterfaceSetting
     * @private
     * @instance
     * @type {string}
     */
    _inputID
    
    /**
     * Stores node for autospin interface setting
     * @memberof AutospinInterfaceSetting
     * @private
     * @instance
     * @type {HTMLElement}
     */
    _node

    /**
     * Threshold function to execute in iron dog framework
     * @memberof AutospinInterfaceSetting
     * @private
     * @instance
     * @type {string}
     */
    _threshold

    /**
     * Stores node for autospin interface setting tooltip
     * @memberof AutospinInterfaceSetting
     * @private
     * @instance
     * @type {boolean}
     */
    _tooltip

    /**
     * Initialize autospin interface setting
     * @param {string}   id_               - ID of setting node
     * @param {string}   function_         - Name of function to execute in iron dog framework
     * @param {number}   index_            - Index of setting in iron dog menu
     * @param {string}   [inputID_=null]   - ID of input field to show grid input
     * @param {string}   [threshold_=null] - Threshold function to execute in iron dog framework
     * @param {function} [checked_=null]   - Function to determine whether setting is permanently checked/on
     * @param {boolean}  [tooltip_=null]   - Whether setting has potential tooltip to display
     * @param {boolean}  [disabled_=false] - Whether setting is disabled or not
     */
    constructor(id_, function_, index_, inputID_ = null, threshold_ = null, checked_ = null, tooltip_ = null, disabled_ = false) {

        this.function   = function_                               //Store name of function to execute
        this.index      = index_                                  //Store index of setting
        this._inputID   = `${inputID_}-new`                       //Store ID of input field
        this.node       = document.getElementById(`${id_}-input`) //Store reference to autospin setting node
        this._threshold = threshold_                              //Store threshold function to execute
        this.checked    = checked_                                //Store whether setting is permanently checked
        this.disabled   = disabled_                               //Store whether setting is disabled

        //If setting is disabled
        if (this.disabled) {
            document.getElementById(id_).classList.add('hidden') //Remove from UI
        }

        //If setting has input field
        else if (inputID_) {

            let input = document.getElementById(this._inputID) //Retrieve input node
         
            //Add touch event
            input.addEventListener('touchstart', (e_) => {

                e_.preventDefault() //Prevent default action

                let menuID    = this._inputID.replace(/-new/g,'')    //Retrieve node ID of menu setting
                let menuInput = document.getElementById(`${menuID}`) //Retrieve menu node

                //Show grid input
                gridInput.show(v_ => {

                    //Set input value in menu & autoplay interface
                    input.innerHTML     = v_
                    menuInput.innerHTML = v_

                    //If setting has threshold function
                    if (threshold_) {
                        autoPlayManager_[threshold_](v_) //Execute threshold function in iron dog framework
                    }

                })

            })

            //If setting has tooltip store node
            tooltip_ ? this.tooltip = document.getElementById(`${inputID_}-tooltip`) : this.tooltip = null

        }

    }

    /** Get checked */ get checked()   { return this._checked }
    /** Set checked */ set checked(v_) { this._checked = v_ }
    
    /** Get function */ get function()   { return this._function }
    /** Set function */ set function(v_) { this._function = v_ }

    /** Get index */ get index()   { return this._index }
    /** Set index */ set index(v_) { this._index = v_ }
    
    /** Get node */ get node()   { return this._node }
    /** Set node */ set node(v_) { this._node = v_ }

    /** Get tooltip */ get tooltip()   { return this._tooltip }
    /** Set tooltip */ set tooltip(v_) { this._tooltip = v_ }

    /** Get disabled */ get disabled()   { return this._disabled }
    /** Set disabled */ set disabled(v_) { this._disabled = v_ }

 }